import React, { useState, useEffect, useRef, useContext, useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import IconButton from '@mui/material/IconButton';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import DetailsPageCard from '../../common/DetailsPage/DetailsPageCard';
import CustomModal from '../../../components/common/CustomModal';
import MessageBox from '../../common/CustomMessageBox';
import CustomDelete from '../../common/CustomDeleteAlert';
import { useExportShipmentDetails } from './Hook/useExportShipmentDetails';
import { DELETE_DUTY, GET_COMPANY_CURRENCY_LIST, GET_PRODUCTS_LIST, GET_SUPPLIERS_LIST, LIST_DUTIES } from '../../../services/apiRoutes';
import { genericPost } from '../../../services/authServices';
import axios from 'axios';
import CustomLoader from '../../common/CustomLoader';
import { AuthContext } from '../../../context/AuthContext';
import { getCurrencyList, getRoundAmount } from '../../../services/CommonServices';
import CreateExpDuty from '../CreateForm/CreateExpDuty';
import UpdateExportDuty from '../UpdateForm/UpdateExportDuty';
import DutyView from '../../importshipement/ViewDetails/DutyView';
import { useCompanyDateFormat } from "../../../constants/useCompanyDateFormat";


const ExportDuty = ({ fetchButtonList }) => {
    const { token } = useContext(AuthContext)
    const companyDateFormat = useCompanyDateFormat();

    const [open, setOpen] = useState(true);
    const [modal, setModal] = useState(false);
    const [updateModal, setUpdateModal] = useState(false);
    const [activeTab, setActiveTab] = useState('duty');
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [message, setMessage] = useState({ open: false, text: '', type: '' });
    const [dutyId, setdutyId] = useState('');
    const [customerList, setCustomerList] = useState([]);
    const [products, setProducts] = useState([]);
    const [viewModal, setViewModal] = useState(false);
    const [newShippingId, setNewShippingId] = useState(null);
    const [currencyList, setCurrencyList] = useState([]);
    const [deleteAlert, setDeleteAlert] = useState(false)
    const [companyCurrencyData, setCompanyCurrencyData] = useState([]);
    const [rowId, setRowId] = useState('')
    const navigate = useNavigate();
    const { exportShipmentId } = useParams();
    const { shipmentDetails, loading: shipmentLoading } = useExportShipmentDetails(exportShipmentId);
    let customerId, cifFob;
    const hasFetched = useRef(false);
    useEffect(() => {
        if (shipmentDetails) {
            customerId = shipmentDetails.customerId;
            cifFob = shipmentDetails.cifFob.cifFobName;
            getCommonData();
            fetchData();
            fetchProductsList();
            getCustomersList();
            fetchDataCompanyCurrency();
            hasFetched.current = true;
        }
    }, [shipmentDetails, updateModal, dutyId, token, deleteAlert, modal]);

    const fetchDataCompanyCurrency = useCallback(async () => {
        const currencyId = shipmentDetails?.currencyId;
        const baseCurrency = shipmentDetails?.company?.baseCurrency;
        if (!currencyId && !baseCurrency) return;
        const idsToSend = [currencyId, baseCurrency].filter(Boolean);
        setLoading(true);
        try {
            const payload = {
                id: idsToSend,
            };
            const response = await genericPost(GET_COMPANY_CURRENCY_LIST, payload);
            if (response.data.success && response.data.currencyList) {
                const formattedCurrencyList = response.data.currencyList.map(currency => ({
                    id: currency.id,
                    name: currency.name,
                    title: `${currency.currency_symbol} ${currency.currency} - ${currency.name}`,
                    currencyName: currency.currency_name,
                    currencySymbol: currency.currency_symbol,
                }));
                setCompanyCurrencyData(formattedCurrencyList);
            } else {
                setError('No currency data found');
            }
        } catch (error) {
            setError('Error fetching currency data');
            console.error('Error fetching currency data', error);
        } finally {
            setLoading(false);
        }
    }, [shipmentDetails]);

    const fetchProductsList = async () => {
        const authToken = sessionStorage.getItem('accessToken');
        const payload = {
            clientCompanyId: customerId,
        };
        try {
            const response = await axios.post(GET_PRODUCTS_LIST, payload, {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                },
            });

            if (response.status === 200 && response.data.success) {
                const productData = response.data.productsList;
                console.log(productData);
                setProducts(productData);
            } else {
                console.error('Failed to fetch products list:', response.data);
            }
        } catch (error) {
            console.error('Error fetching products list:', error);
        }
    };
    const getCustomersList = async () => {
        try {
            const payload = {
                clientCompanyId: customerId,
            };
            const response = await genericPost(GET_SUPPLIERS_LIST, payload, {
            });
            if (response.data && response.data.success && response.data.clientCompanies) {
                const customersData = response.data.clientCompanies.map((customer) => ({
                    id: customer.clientCompanyId,
                    title: customer.clientCompanyName,
                }));
                setCustomerList(customersData);
            } else {
                return [];
            }
        } catch (error) {
            console.error('Error fetching customer list:', error);
            return [];
        }
    };
    const getCommonData = async () => {
        const currencyListData = await getCurrencyList();
        setCurrencyList(currencyListData);
    }
    const fetchData = async () => {
        setLoading(true);
        try {
            const payload = {
                clientCompanyId: customerId,
                shipmentId: shipmentId,
                commanShipmentId: 1,
            };
            const response = await genericPost(LIST_DUTIES, payload);

            if (response.data.success) {
                const duties = response.data.duty.map((duty, index) => {
                    const boeConversion = parseFloat(duty.boeConversionRate || 0);
                    const totalAmount = getRoundAmount(duty.particulars.reduce((acc, item) => acc + parseFloat(item.amount || 0), 0));
                    const totalDuty = getRoundAmount(duty.particulars.reduce((acc, item) => acc + parseFloat(item.duty || 0), 0));
                    const totalTax = getRoundAmount(duty.particulars.reduce((acc, item) => acc + parseFloat(item.tax || 0), 0));
                    const firstProductName = duty.particulars[0]?.products?.productName || '';
                    const baseCurrency = shipmentDetails?.company?.baseCurrencyData?.currency_symbol ?? '';
                    const currencyDutyList = duty.particulars[0]?.currencyDutyList?.currency_symbol || '';
                    const currencyTaxList = duty.particulars[0]?.currencyTaxList?.currency_symbol || '';

                    return {
                        index: (index + 1).toString().padStart(2, '0'),
                        dutyId: duty.dutyId || '',
                        userId: duty.userId || '',
                        companyId: duty.companyId || '',
                        clientCompanyId: duty.clientCompanyId || '',
                        currencyName: duty.currency?.currency || '',
                        shipmentId: duty.shipmentId || '',
                        voucherNo: duty.voucherNo || '',
                        date: companyDateFormat(duty?.date) || '',
                        currencyId: duty.currencyId || '',
                        boeConversionRate: `${baseCurrency} ${(parseFloat(duty.boeConversionRate || 0)).toFixed(2)}`,
                        boeUpload: duty.boeUpload || '',
                        note: duty.note || '',
                        boeNumber: duty.boeNumber || '',
                        createdAt: duty.createdAt || '',
                        updatedAt: duty.updatedAt || '',
                        totalAmount: `${duty.currency?.currency_symbol || ''} ${totalAmount ? totalAmount.toFixed(2) : ''}`,
                        totalDuty: `${currencyDutyList} ${(totalDuty).toFixed(2)}`,
                        totalTax: `${currencyTaxList} ${(totalTax).toFixed(2)}`,
                        productName: firstProductName,
                        particulars: duty.particulars.map(({ dutyParticularId, particular, hsn, duty, amount, tax, dutyPersentage, taxPersentage }) => ({
                            dutyParticularId,
                            particular,
                            hsn,
                            duty,
                            amount: parseFloat(amount).toFixed(2),
                            tax,
                            dutyPersentage,
                            taxPersentage,
                        }))
                    };
                });
                const { newShippingId } = response.data;
                setNewShippingId(newShippingId);
                setData(duties); // Store the parsed data
            } else {
                setError('No duties found');
            }
        } catch (error) {
            setError('Error fetching duties');
            console.error('Error fetching duties', error);
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async (dutyId) => {
        setLoading(true);
        const authToken = sessionStorage.getItem('accessToken');

        try {
            const response = await axios.delete(DELETE_DUTY(dutyId), {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                },
            });

            if (response.status === 200) {
                setDeleteAlert(false);
                setMessage({
                    open: true,
                    text: "deleted successfully",
                    type: "success",
                });
                fetchData();
                fetchButtonList();
            } else {
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);

            if (error.response) {
                if (error.response.status === 409) {
                    setMessage({
                        open: true,
                        text: error.response.data?.error || "Cannot delete Data. Related Shipment exists.",
                        type: "error",
                    });
                } else {
                    setMessage({
                        open: true,
                        text: "An error occurred while deleting the Data.",
                        type: "error",
                    });
                }
            } else {
                console.error("Error deleting Data", error);
                setMessage({
                    open: true,
                    text: "Network error. Please try again later.",
                    type: "error",
                });
            }
        }
    };
    // Table columns
    const columns = [
        {
            accessor: 'index', label: 'SN', id: 'index', styleAccessor: {
                textAlign: 'center', maxWidth: '200px', width: "50px"
            },
        },
        {
            id: 'voucherNo', label: 'Voucher No.', accessor: 'voucherNo', styleAccessor: {
                textAlign: 'center'
            }
        },

        {
            id: 'date', label: 'Date', accessor: 'date', styleAccessor: {
                textAlign: 'center'
            }
        },
        { id: 'currencyName', label: 'Currency', accessor: 'currencyName' },

        { id: 'productName', label: 'Product Name', accessor: 'productName' },
        {
            id: 'boeConversionRate', label: 'boe Conversion Rate', accessor: 'boeConversionRate', styleAccessor: {
                textAlign: 'right',
            },
        },
        {
            id: 'boeNumber', label: 'BOE Number', accessor: 'boeNumber', styleAccessor: {
                textAlign: 'center'
            }
        },
        {
            id: 'totalAmount', label: 'Invoice Amount', accessor: 'totalAmount', styleAccessor: {
                textAlign: 'right',
            },
        },

        {
            id: 'totalDuty', label: 'Duty Amount', accessor: 'totalDuty', styleAccessor: {
                textAlign: 'right',
            },
        },
        {
            id: 'totalTax', label: 'Tax Amount', accessor: 'totalTax', styleAccessor: {
                textAlign: 'right',
            },
        },
        {
            id: 'action',
            label: 'Action',
            accessor: 'action',
            Cell: ({ row }) => (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '1px' }}>
                    <IconButton onClick={() => handleViewClick(row.dutyId)} style={{ marginRight: '1px' }}>
                        <VisibilityIcon style={{ color: '#059212' }} />
                    </IconButton>
                    <IconButton onClick={() => handleUpdateClick(row.dutyId)} style={{ marginRight: '1px' }}>
                        <ModeEditOutlineOutlinedIcon style={{ color: '#050C9C' }} />
                    </IconButton>
                    <IconButton onClick={() => handleOpenDeleteAlert(row.dutyId)}>
                        <DeleteOutlineOutlinedIcon style={{ color: '#E4003A' }} />
                    </IconButton>
                </div>
            ),
        },
    ];
    const handleUpdateClick = (id) => {
        setdutyId(id);
        setUpdateModal(true);
    };
    const handleOpenDeleteAlert = (rowId) => {
        setDeleteAlert(true)
        setRowId(rowId)
    }

    const handleOpen = () => {
        setModal(true);
    };

    const handleClose = () => {
        setModal(false);
    };

    const handleCloseUpdate = () => {
        setUpdateModal(false);
        setdutyId('');
    };
    const handleViewClick = (id) => {
        setdutyId(id);
        setViewModal(true);
    };

    const handleCloseView = () => {
        setViewModal(false);
        setdutyId('');
    };


    if (!shipmentDetails) {
        return <p>    <CustomLoader open={shipmentLoading} /> </p>;
    }

    const companyName = shipmentDetails.customer.clientCompanyName;
    const phoneNumber = shipmentDetails.customer.mobile;
    const customerName = shipmentDetails.customerId;
    const shipmentId = shipmentDetails.shipmentId;
    const currencySymbol = shipmentDetails?.currency?.currency_symbol ?? '';
    const currencyShort = shipmentDetails?.currency?.currency ?? '';
    const currencyId = shipmentDetails?.currency?.id ?? '';
    const shipmentOrgId = shipmentDetails.exportShipmentId;
    const currencySym = shipmentDetails?.company?.baseCurrencyData?.currency_symbol ?? '';
    const basecurrencyId = Number(shipmentDetails?.company?.baseCurrency) || null;

    return (
        <div>
            <CustomLoader open={loading} />
            <DetailsPageCard
                columns={columns}
                title="Duty"
                buttonTitle="Create Duty"
                handleOpen={handleOpen}
                data={data}
                loading={loading}
                error={error}
            />
            <CustomModal open={modal}  >
                <CreateExpDuty
                    fetchData={fetchData}
                    setMessage={setMessage}
                    handleClose={handleClose}
                    customerList={customerList}
                    shipmentId={shipmentId}
                    productsList={products}
                    customerName={customerName}
                    currencyList={currencyList}
                    currencyId={currencyId}
                    currencySymbol={currencySymbol}
                    newShippingId={newShippingId}
                    shipmentOrgId={shipmentOrgId}
                    fetchButtonList={fetchButtonList}
                    currencySym={currencySym}
                    companyCurrencyData={companyCurrencyData}
                    basecurrencyId={basecurrencyId}
                />
            </CustomModal>
            <CustomModal open={updateModal}  >
                <UpdateExportDuty
                    shipmentId={shipmentId}
                    customerName={customerName}
                    fetchData={fetchData}
                    setMessage={setMessage}
                    handleClose={handleCloseUpdate}
                    dutyId={dutyId}
                    suppliersList={customerList}
                    productsList={products}
                    currencyList={currencyList}
                    currencySym={currencySym}
                    currencySymbol={currencySymbol}
                    companyCurrencyData={companyCurrencyData}
                    basecurrencyId={basecurrencyId}
                    currencyId={currencyId}
                />
            </CustomModal>
            <CustomModal open={viewModal} handleClose={handleCloseView}>
                <DutyView
                    fetchData={fetchData}
                    handleClose={handleCloseView}
                    dutyId={dutyId}
                    productsList={products}
                    currencySym={currencySym}
                />
            </CustomModal>

            <MessageBox
                open={message.open}
                onClose={() => setMessage({ ...message, open: false })}
                message={message.text}
                handleClose={() => setMessage({ ...message, open: false })}
                type={message.type}
            />
            <CustomDelete
                handleDelete={handleDelete}
                open={deleteAlert}
                rowId={rowId}
                handleClose={() => setDeleteAlert(false)}
            />
        </div>
    );
};

export default ExportDuty;
